import "./NewsFeatureGroups.scss";
import DateInput from "@/components/Common/DateInput/DateInput.vue";
import NewsFeatureGroupsList from "@/components/News/NewsFeatureGroupsList/NewsFeatureGroupsList.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import _ from "lodash";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "NewsFeatureGroups",
  components: { DateInput, NewsFeatureGroupsList },

  data: () => ({
    dialog: false,
    headers: [
      { text: "Titel", value: "title" },
      { text: "Erstellt", value: "create_date" },
      { text: "Geändert", value: "change_date" },
      { text: "Sortierung Backend", value: "sort" },
      {
        text: "Aktionen",
        value: "actions",
        sortable: false,
        align: "center",
        width: "5%"
      }
    ],
    editedItem: {
      title: ""
    },
    defaultItem: {
      title: ""
    },
    editLoading: false
  }),
  async mounted() {
    if (!this.isAdmin && !this.isNewsAdmin) {
      return await this.$router.push(`/news/`);
    }
    await this.$store.dispatch("getNewsConfig");
    await this.loadFeatureGroups();
  },
  computed: {
    featureGroups() {
      return this.$store.state.newsFeatureGroups ?? [];
    },
    formTitle() {
      return this.editedItem.isNew
        ? "Merkmalsgruppe anlegen"
        : "Merkmalsgruppe bearbeiten";
    },
    currentPrincipal() {
      return this.$store.state.selectedPrincipal.id;
    },
    globalFeatureGroups() {
      return this.$store.state.newsFeatureGroups?.length
        ? this.getGlobalFeatureGroups(null)
        : [];
    },
    subscribedFeatureGroups: {
      get() {
        return this.getGlobalFeatureGroups(true);
      },
      async set(newVal) {
        const oldVal = this.subscribedFeatureGroups,
          changedValues = [],
          globalGroups = this.getGlobalFeatureGroups(null);

        if (newVal.length > oldVal.length)
          newVal.forEach(val => {
            if (!oldVal.find(ov => ov._id === val)) {
              const changedVal = globalGroups?.find(group => group._id === val);
              changedVal.principals.push(this.currentPrincipal);

              changedValues.push(changedVal);
            }
          });
        else
          oldVal.forEach(val => {
            if (!newVal.find(nv => nv === val._id)) {
              val.principals.remove(this.currentPrincipal);
              changedValues.push(val);
            }
          });

        await changedValues.asyncForEach(async val => {
          await this.updateFeatureGroup(val);
        });
      }
    },
    ownFeatureGroups() {
      return (
        this.featureGroups.filter(
          featureGroup => featureGroup.owner === this.currentPrincipal
        ) || []
      );
    },
    channels() {
      const standardChannels =
        this.$store.state.newsConfig.standard_channels ?? [];
      const ownChannels = this.$store.state.newsConfig.own_channels ?? [];
      return standardChannels.concat(ownChannels);
    },
    principals() {
      return this.$store.state.principals ?? [{}];
    },
    isAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:admin");
    },
    isNewsAdmin() {
      return this.$store.state.currentUser?.scopes.includes("role:news_admin");
    },
    total() {
      return this.ownFeatureGroups?.length;
    },
    isValid() {
      return this.editedItem?.title?.length;
    }
  },
  methods: {
    async createError(error) {
      this.$store.dispatch("createError", error);
    },
    async createSuccess(successMessage) {
      this.$store.dispatch("createSuccess", successMessage);
    },
    async loadFeatureGroups() {
      try {
        await this.$store.dispatch("getFeatureGroups", {
          principal_id: this.currentPrincipal,
          ignorePrincipalId: this.isAdmin ? "1" : "0"
        });
      } catch (err) {
        this.$emit("createError", err);
      }
    },

    getGlobalFeatureGroups(subscribed) {
      if (this.featureGroups && this.currentPrincipal) {
        const principalId =
          typeof this.currentPrincipal === "string"
            ? this.currentPrincipal
            : "xx";
        const featureGroups = this.featureGroups.filter(
          feature =>
            !feature.owner &&
            (subscribed === null
              ? true
              : subscribed
              ? feature.principals.includes(principalId)
              : !feature.principals.includes(principalId))
        );
        if (!subscribed)
          featureGroups.forEach(featureGroup => {
            featureGroup.features = _.sortBy(featureGroup.features, feature =>
              feature.title.toLowerCase()
            );
          });
        return featureGroups;
      } else return [];
    },

    createItem(global = false) {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem.isNew = true;
      this.editedItem.owner = this.currentPrincipal;
      this.editedItem.principals = [this.currentPrincipal];
      if (global) {
        this.editedItem.owner = null;
      }

      this.dialog = true;
      this.$refs?.editForm?.reset();
    },
    editItem(item) {
      this.editedIndex = this.ownFeatureGroups.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.isNew = false;
      this.dialog = true;
    },
    deleteItem(item) {
      this.$confirm(
        `Sind Sie sicher, dass Sie 
        <br>"${item.title}" löschen wollen?`,
        confirmWarningConfig
      ).then(async res => {
        if (res) {
          try {
            await this.deleteFeatureGroup(item);
          } catch (err) {
            this.createError(err);
            return;
          }
          this.editedIndex = this.ownFeatureGroups.indexOf(item);
          this.editedItem = Object.assign({}, item);
          this.ownFeatureGroups.splice(this.editedIndex, 1);
          this.closeDelete();
        }
      });
    },
    async deleteFeatureGroup(item) {
      const title = item.title;
      const params = {
        principal_id: this.currentPrincipal
      };
      const headers = getTokenHeader(),
        res = await axios.delete(
          `${env.news_api_client_url}feature_group/${item._id}`,
          {
            headers,
            params
          }
        );
      if (res.status === 200) {
        this.createSuccess(title + " gelöscht!");
      } else {
        this.createError({ ...res, text: item.title + " nicht gelöscht!" });
      }
      await this.loadFeatureGroups();
    },
    async afterSave(close) {
      await this.loadFeatureGroups();
      if (close) {
        this.close();
      }
      this.createSuccess("Erfolgreich gespeichert!");
    },
    close() {
      this.editedItem = { ...this.defaultItem };
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save(close) {
      if (this.$refs.editForm.validate()) {
        let success = false;
        this.loadingStatus(true);
        try {
          success = this.editedItem.isNew
            ? await this.createFeatureGroup()
            : await this.updateFeatureGroup();
          if (success) {
            this.afterSave(close);
          }
        } catch (ex) {
          this.createError(ex);
        }
        this.loadingStatus(false);
      } else {
        this.createError({
          text: "Nicht gespeichert! Bitte alle Pflichtfelder überprüfen!"
        });
      }
    },
    async updateFeatureGroup(item) {
      if (item?._id) this.editedItem = item;
      const headers = getTokenHeader(),
        res = await axios.put(
          `${env.news_api_client_url}feature_group`,
          this.editedItem,
          { headers }
        );
      return res.status === 200;
    },
    async updateSort(paramHandler) {
      const { direction, item } = paramHandler;
      if (direction === "up") {
        if (item.sort > 0) item.sort -= 1;
      } else item.sort += 1;
      const success = await this.updateFeatureGroup(item);
      if (success)
        await this.$store.dispatch("createSuccess", "Erfolgreich gespeichert!");
      else await this.$store.dispatch("createError");
    },
    async createFeatureGroup() {
      const headers = getTokenHeader(),
        res = await axios.post(
          `${env.news_api_client_url}feature_group`,
          this.editedItem,
          { headers }
        );
      this.editedItem.isNew = false;
      this.editedItem._id = res.data._id;
      return res.status === 200;
    },
    loadingStatus(status) {
      this.editLoading = status;
    }
  }
};
